(function ($, window, document) {

function onDOMContentLoaded() {
  $(window).resize(adjust);

  function adjust() {
    var $features = $('.feature-list .feature__box .feature');

    // Note, this easily breaks and currently relies on the fact that xs has borders and other don't
    if ($features.css('border-top-width') == '1px') {
      $features.find('.feature__description').removeClass('in');
      $features.on('click', function (e) {
        e.preventDefault();
      }).attr('data-toggle', 'collapse');
    } else {
      $features.find('.feature__description').addClass('in');
      $features.off('click').removeAttr('data-toggle');
    }
  }

  // adjust when document is ready
  adjust();
}
if (document.readyState == 'loading') {
  document.addEventListener("DOMContentLoaded", onDOMContentLoaded);
} else {
  onDOMContentLoaded();
}

})(jQuery, window, document);
